const BACKOFFICE_SUFFIX = "Mega Match Backoffice";
const DEFAULT_APP_NAME = "Mega Match";
const DEFAULT_SCREEN_NAME = "Dashboard";

function normalizeSegment(value, fallback) {
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed) {
      return trimmed;
    }
  } else if (typeof value === "number" && !Number.isNaN(value)) {
    return String(value);
  }

  return fallback;
}

export function formatPageTitle(appName, screenName) {
  const normalizedApp = normalizeSegment(appName, DEFAULT_APP_NAME);
  const normalizedScreen = normalizeSegment(screenName, DEFAULT_SCREEN_NAME);
  return `${normalizedApp} | ${normalizedScreen} | ${BACKOFFICE_SUFFIX}`;
}

export function applyPageTitle(options = {}) {
  if (typeof document === "undefined") {
    return;
  }

  const { appName, screenName } = options;
  document.title = formatPageTitle(appName, screenName);
}

export { BACKOFFICE_SUFFIX, DEFAULT_APP_NAME, DEFAULT_SCREEN_NAME };
